import { t } from "i18next";

export const varNames = {
    /**
     * @Note "Global variables" are values that do not change over lines
     * @Note In the custom statement, lines are repeated for each milestones.
     * Global variables : main infos, beneficiary, period, date etc.
     */
    date: t("PartnerStatements.Variables.Date"),
    editDate: t("PartnerStatements.Variables.EditDate"),
    period: t("PartnerStatements.Variables.Period"),
    periodStart: t("PartnerStatements.Variables.PeriodStart"),
    periodEnd: t("PartnerStatements.Variables.PeriodEnd"),
    beneficiary: t("PartnerStatements.Variables.Beneficiary"),
    street: t("PartnerStatements.Variables.BeneficiaryStreet"),
    city: t("PartnerStatements.Variables.BeneficiaryCity"),
    country: t("PartnerStatements.Variables.BeneficiaryCountry"),
    cumulativeRoyaltiesUntilN: t("PartnerStatements.Variables.CumulativeRUN"), // Droits cumulés à l'ouverture de la période (global)
    royaltiesN: t("PartnerStatements.Variables.RoyaltiesN"), // Total des droits sur la période
    term_period_data_grossRoyalties: t("PartnerStatements.Variables.TotalGrossRoyalties"),
    term_period_data_netRoyalties: t("PartnerStatements.Variables.TotalNetRoyalties"),
    /**
     * Repeatable variables : related to the term (does't change over milestones)
     */
    title: t("PartnerStatements.Variables.Title"),
    ean13: "EAN13",
    channel: t("PartnerStatements.Variables.Channel"),
    price: t("PartnerStatements.Variables.Price"),
    countryMarket: t("PartnerStatements.Variables.CountryMarket"),
    currency: t("PartnerStatements.Variables.Currency"),
    releaseDate: t("PartnerStatements.Variables.ReleaseDate"),
    associatedBrand: t("PartnerStatements.Variables.AssociatedBrand"),
    advance: t("PartnerStatements.Variables.Advance"),
    reference: t("PartnerStatements.Variables.Reference"),
    sku: t("PartnerStatements.Variables.SKU"),
    term_CumulativeRights: t("PartnerStatements.Variables.TermCumulativeRights"),
    cumulativeRightsUntilN: t("PartnerStatements.Variables.CumulativeRightsUntilN"), // Droits cumulés avant la période (par titre)
    cumulativeSales: t("PartnerStatements.Variables.CumulativeSales"), // Ventes cumulées avant la période (par titre)
    initialProvision: t("PartnerStatements.Variables.InitialProvision"),
    currentProvision: t("PartnerStatements.Variables.CurrentProvision"),
    provisionPercent: t("PartnerStatements.Variables.ProvisionPercent"),
    term_royaltiesIncludingInitialProvision: t("PartnerStatements.Variables.RoyaltiesIncludingInitialProvision"),
    term_royalties: t("PartnerStatements.Variables.TermRoyalties"),
    term_period_data_balance: t("PartnerStatements.Variables.TermPeriodDataBalance"),
    termId: t("PartnerStatements.Variables.TermId"),
    newCumulativeRoyalties: t("PartnerStatements.Variables.NewCumulativeRoyalties"),
    newCumulativeSales: t("PartnerStatements.Variables.NewCumulativeSales"),
    /**
     * Variables for each sales milestone
     */
    quantity: t("PartnerStatements.Variables.Quantity"),
    percentage: t("PartnerStatements.Variables.Percentage"),
    milestone: t("PartnerStatements.Variables.Milestone"),
    grossSales: t("PartnerStatements.Variables.GrossSales"), // Chiffre d'affaires sur titre (sur palier donné)
    royalties: t("PartnerStatements.Variables.Royalties"), // Droits sur titre (sur palier donné)
};

export const statementVariables = Object.keys(varNames);
